import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { MediaMovieApiModel } from '@rocksoft/inroom-sdk';

@Component({
  selector: 'era-movie',
  templateUrl: './movie.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./movie.component.scss'],
})
export class MovieComponent {
  readonly movie = input.required<MediaMovieApiModel>();
}
